import { Injectable, signal } from '@angular/core';
import { ILanguage } from '../interfaces/ILanguage';
import { TranslationDictionary } from '../types';

@Injectable({ providedIn: 'root' })
export class LanguageStore {

  public static instance: LanguageStore;

  public readonly languages = signal<ILanguage[]>([]);
  public readonly language = signal<ILanguage | null>(null);
  public readonly dictionary = signal<TranslationDictionary>({});

  public constructor() {
    LanguageStore.instance = this;
  }
}
